import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileAndLocalDatesWithDividerComponent } from './profile-and-local-dates-with-divider.component';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TimezoneModule } from '../timezone/timezone.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { DateWithProfileAndLocalTimezoneModule } from '../profile-and-local-date/date-with-profile-and-local-timezone.module';

@NgModule({
  declarations: [ProfileAndLocalDatesWithDividerComponent],
  imports: [CommonModule, IntrackFeatureModule, TimezoneModule, SvgIconModule, DateWithProfileAndLocalTimezoneModule],
  exports: [ProfileAndLocalDatesWithDividerComponent],
})
export class ProfileAndLocalDatesWithDividerModule {}
